import React from 'react';
import {
    defineBlock,
    smartProps,
    useSmartProp,
    useInspectorControl,
    BlockWrapper,
    useEditor,
} from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';
import style from './block.module.scss';
import useResponsive from '../hooks/useResponsive';
import MinimalWrapper from '../minimal-wrapper/block';

function Inspector() {
    const [height, setHeight] = useSmartProp('height');
    const [tabletHeight, setTabletHeight] = useSmartProp('tabletHeight');
    const [mobileHeight, setMobileHeight] = useSmartProp('mobileHeight');

    return (
        <>
            <PanelBody title="Height configuration" initialOpen={true}>
                <PanelRow>
                    <TextControl label={'Spacer height (px)'} value={height} onChange={(value) => setHeight(value)} />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label={'Height of tablet spacer (px)'}
                        value={tabletHeight}
                        onChange={(value) => setTabletHeight(value)}
                    />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label={'Height of mobile spacer (px)'}
                        value={mobileHeight}
                        onChange={(value) => setMobileHeight(value)}
                    />
                </PanelRow>
            </PanelBody>
        </>
    );
}

function Block({ height, tabletHeight, mobileHeight }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    const isMobile = useResponsive('down', 'sm');
    const isTablet = useResponsive('down', 'md');
    const spacerHeight = isMobile ? mobileHeight : isTablet ? tabletHeight : height;

    return (
        <MinimalWrapper>
            {isEditing ? (
                <BlockWrapper.Div>
                    <div className={style.block} style={{ height: spacerHeight + 'px' }}></div>
                </BlockWrapper.Div>
            ) : (
                <BlockWrapper.Without>
                    <div className={style.block} style={{ height: spacerHeight + 'px' }}></div>
                </BlockWrapper.Without>
            )}
        </MinimalWrapper>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        height: smartProps.string.withDefault(50),
        tabletHeight: smartProps.string.withDefault(40),
        mobileHeight: smartProps.string.withDefault(30),
    },
    setup: {
        title: 'Spacer',
    },
});
